import { styled, keyframes } from 'goober';
import { COLORS } from '@shared/config/colors/colors';

const toShow = keyframes`
    from {
        opacity: 0;
        transform: translateY(16px);
    }
    to {
        opacity: 1;
        transform: translateY(0px);
    }
`;

const toHide = keyframes`
    from {
        opacity: 1;
        transform: translateY(0px);
    }
    to {
        opacity: 0;
        transform: translateY(16px);
    }
`;

const hidden = keyframes`
    to {
        display: none;
    }
`;

export const Wrapper = styled('div')<{ isShow: boolean }>`
    display: flex;
    padding: 16px 20px 16px 20px;
    background-color: ${COLORS.neutral_00};
    border: 1px solid ${COLORS.bright_blue};
    border-radius: 20px;
    display: ${({ isShow }) => (isShow ? 'flex' : 'none')};

    ${({ isShow }) => isShow && `animation: ${toShow} 0.16s ease 0s both;`}
    ${({ isShow }) => !isShow && `animation: ${toHide} 0.16s ease 0s forwards, ${hidden} 0s ease 0.16s forwards;`}
`;

export const IconWrapper = styled('div')`
    width: 48px;
    height: 44px;
    margin-right: 16px;
`;

export const ActionWrapper = styled('div')`
    margin-left: auto;
    display: flex;
    flex-direction: column;
    align-items: flex-start;

    > p:first-child {
        margin-bottom: 4px;
    }

    > button {
        margin-top: 12px !important;
    }
`;
